import React from 'react';
import _ from 'lodash';
import $ from 'jquery';
import ThumbnailUtil from '../../../util/ThumbnailUtil';
import Scrollable from '../../../common/Scrollable';
import UnreadComments from '../../../panels/unread-comments/UnreadComments';
import UserProfileImage from './../../../common/UserProfileImage';
import ViewUtil from './../../../ViewUtil';

import './ActivityPanel.css';
import Store from '../../../store/Store';
import UnreadCommentsData from '../../../queries/annotations/UnreadCommentsData';
import LazyLoad from 'react-lazy-load';
import ImageLoader from '../../../common/imageloader/ImageLoader';
import '../../../common/imageloader/ImageLoader.css';
import Action from '../../../common/Action';
import t from '../../../i18n/I18n';
import Button from '../../../common/Button';
import { ThemeSetup } from '../../../themes/ThemeSetup';
import { isMobile } from '../../../util/ScreenUtil';
import DateTimeUtil from '../../../util/DateTimeUtil';
import { Div } from '../../../common/elements';

type Props = {
  activities: string[],
  emptyPrompt: string,
  width: string,
  loadingActivities: boolean,
  loadMoreActivities: Function,
  onClickEvent: Function,
  onClose: Function,
  action: number[]
};

type State = {
  tab: string
};

export const ActivityTabs = {
  ACTIVITY: 1,
  NOTIFICATIONS: 2
};

export default class ActivityPanel extends React.Component<Props, State> {
  _showNotificationPanel: boolean;

  static defaultProps = {
    activities: [],
    emptyPrompt: t('NO_ACTIVITY_FOUND'),
    width: '',
    loadMoreActivities: _.noop,
    action: [ActivityTabs.ACTIVITY, ActivityTabs.NOTIFICATIONS]
  };

  constructor(props) {
    super(props);
    /**
     * @type {UnreadCommentsData}
     */
    const unreadCommentsData = Store.get(UnreadCommentsData.NAME);
    const collectionUnreadCountEntries = unreadCommentsData
      ? unreadCommentsData.getCollectionUnreadCountEntries()
      : undefined;
    this.state = {
      tab:
        _.isEmpty(props.activities) && !_.isEmpty(collectionUnreadCountEntries)
          ? ActivityTabs.NOTIFICATIONS
          : ActivityTabs.ACTIVITY
    };

    this._showNotificationPanel = true;
  }

  getHeight = () => {
    return window.innerHeight - 104;
  };

  switchTab = (tab) => {
    this.setState({ tab });
  };

  render() {
    /**
     * @type {UnreadCommentsData}
     */
    const unreadCommentsData = Store.get(UnreadCommentsData.NAME);
    const collectionUnreadCountEntries = unreadCommentsData
      ? unreadCommentsData.getCollectionUnreadCountEntries()
      : undefined;
    const { activities, loadingActivities, loadMoreActivities, width, emptyPrompt, onClose, action } = this.props;

    const { tab } = this.state;
    let activityCls = '',
      commentsCls = '',
      empty,
      scrollProps,
      children;
    let activtyTabStyle = { height: this.getHeight(), padding: '10px 15px' };

    if (tab === ActivityTabs.ACTIVITY) {
      const indexEnd = activities.findIndex((x) => x._dateLabel && x._dateLabel !== 'Today');
      activityCls = 'active';
      empty = _.isEmpty(this.props.activities);
      scrollProps = {
        style: activtyTabStyle,
        onReachBottom: loadMoreActivities,
        loading: loadingActivities
      };
      children = _.map(activities, (activity, index) => this.renderActivity(activity, index, indexEnd));
    } else {
      commentsCls = 'active';
      empty = _.isEmpty(collectionUnreadCountEntries);
      scrollProps = {
        style: activtyTabStyle,
        onReachBottom: _.noop,
        loading: false
      };
      children = <UnreadComments onClose={onClose} />;
    }

    const showActivityPanel = _.includes(action, ActivityTabs.ACTIVITY);
    const showCommentsPanel = _.includes(action, ActivityTabs.NOTIFICATIONS);
    const showBoth = showCommentsPanel && showActivityPanel;
    const panelWidth = isMobile() ? '100%' : 370;
    return (
      <div id="ActivityPanel" name="ActivityPanel" style={{ width: panelWidth, minHeight: window.innerHeight - 70 }}>
        <header className="flex-row">
          {this.props.displayedBy === 'HomePage' || isMobile() ? null : (
            <Button
              className="activity-cross"
              style={{ paddingLeft: '5px' }}
              icon="images/close_gray.svg"
              onClick={this.props.hideNotification}></Button>
          )}

          <Action custom predicates={[() => showActivityPanel]}>
            <span className={activityCls} onClick={() => this.switchTab(ActivityTabs.ACTIVITY)}>
              {t('ACTIVITY')}
            </span>
          </Action>
          <Action custom predicates={[() => showCommentsPanel]}>
            <span
              className={commentsCls}
              style={{ marginLeft: showBoth ? '' : isMobile() ? '25%' : '65px' }}
              onClick={() => this.switchTab(ActivityTabs.NOTIFICATIONS)}>
              {t('NOTIFICATIONS')}
            </span>
          </Action>
        </header>
        {!empty ? (
          <Scrollable {...scrollProps}>{children}</Scrollable>
        ) : (
          <div>
            <div style={{ padding: '20px', color: '#B5B5B5' }}>
              {tab === ActivityTabs.ACTIVITY ? emptyPrompt : t('NO_COMMENTS_FOUND')}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderActivity(activity, index, indexEnd) {
    const isFile = activity.isFile();
    const showTB = activity.getFuid() > 0;
    const messageToShow = activity._message ? activity._message.replace(/<b>|<\/b>/g, '') : '';
    const isNotClickable = activity.isNotClickable();
    // this.parseActivityMsg(activity._message);
    return (
      <div
        onMouseEnter={(event) => {
          if (!isNotClickable) $(event.currentTarget).css('box-shadow', 'var(--box-shadow-primary) 0px 4px 9px 0px');
        }}
        onMouseLeave={(event) => {
          if (!isNotClickable) $(event.currentTarget).css('box-shadow', '');
        }}
        key={index}
        style={{ color: '#B5B5B5', fontSize: '12px', marginBottom: '10px' }}>
        {activity._dateLabel ? (
          <div style={{ marginBottom: '10px', fontWeight: 600 }}>{activity._dateLabel}</div>
        ) : null}
        <div
          onClick={() => this.props.onClickEvent(activity)}
          style={styles.activity}
          className={activity.isNotClickable() ? null : 'isHovered'}>
          <div style={{ float: 'left', width: '56px', padding: '10px' }}>
            <UserProfileImage userId={activity.getUsername()} size={35} />
          </div>
          <div
            style={{
              float: 'left',
              width: 'calc(100% - 56px)',
              padding: '10px 10px 10px 0',
              fontSize: '12px',
              overflowWrap: 'break-word'
            }}>
            <Div
              className="text-ellipsis"
              title={messageToShow}
              style={{ color: 'var(--primary-font-color-selected)', marginBottom: '10px' }}>
              {messageToShow}
            </Div>
            <div>
              <div>
                {/* <img
                  src={this.getThumbnailUrl(activity, isFile)}
                  style={{ objectFit: "cover", height: showTB ? isFile ? '107px' : '22px' : '0px', maxWidth: '100%' }} /> */}
                <LazyLoad threshold={0} height={isFile ? 100 : 15} debounce={true}>
                  <ImageLoader
                    src={this.getThumbnailUrl(activity, isFile)}
                    style={{
                      objectFit: 'cover',
                      height: showTB ? (isFile ? '107px' : '22px') : '0px',
                      maxWidth: '100%'
                    }}
                  />
                </LazyLoad>
              </div>
            </div>
            {indexEnd != 0 && index < indexEnd ? (
              <TimeLabelForActivityItemToday mTime={activity.getMtime()} timeLabel={activity.getTimeLabel()} />
            ) : (
              <TimeLabelForActivityItem timeLabel={activity.getTimeLabel()} />
            )}
          </div>
        </div>
      </div>
    );
  }

  getThumbnailUrl(activity, isFile) {
    if (isFile)
      return ThumbnailUtil.getThumnailUrl(true, activity.getBid(), activity.getFuid(), -1, activity.getName());
    else return ThumbnailUtil.getFolderIcon();
  }

  getProfilePicUrl(activity) {
    return ThumbnailUtil.avatar(activity.getUsername());
  }
}

function TimeLabelForActivityItem(props: { timeLabel: string }) {
  return <div style={{ color: '#B5B5B5', marginTop: '15px' }}>{props.timeLabel}</div>;
}
function TimeLabelForActivityItemToday(props: { mTime: string, timeLabel: string }) {
  const time = DateTimeUtil.format(props.mTime);
  const currentTime = new Date().getTime();
  const timeDiff = currentTime - props.mTime;
  if (timeDiff <= 120000) return <div style={{ color: '#B5B5B5', marginTop: '15px' }}>{props.timeLabel}</div>;
  else return <div style={{ color: '#B5B5B5', marginTop: '15px' }}>{time.relative}</div>;
}
const styles = {
  activity: {
    background: 'var(--primary-header-bg)',
    boxShadow: 'rgba(0, 0, 0, 0.1) 2px 2px 10px -2px',
    overflow: 'hidden',
    marginBottom: '10px',
    borderRadius: '2px'
    // cursor: 'pointer'
  },
  activitiesHeader: {
    color: '#7A7A7A',
    display: 'inline-block',
    fontSize: '14px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '100% 7px',
    paddingRight: '15px',
    cursor: 'pointer',
    marginBottom: '10px'
  },
  fileIcon: {
    height: '107',
    width: '107'
  },
  folderIcon: {
    height: '22',
    width: '26'
  }
};
